import { supabase } from "@/integrations/supabase/client";
import type { Json } from "@/integrations/supabase/types";
import { useAuth } from "@/contexts/AuthContext";
import { useDemo } from "@/contexts/DemoContext";
import { useCallback } from "react";

function toJson(value: unknown): Json {
  return JSON.parse(JSON.stringify(value ?? {})) as Json;
}

export function useAuditLog() {
  const { profile } = useAuth();
  const { isDemo } = useDemo();

  const log = useCallback(
    async (action: string, entityType: string, entityId: string, changes?: Record<string, unknown>) => {
      if (isDemo || !profile?.business_id) return;
      try {
        await supabase.from("audit_events").insert({
          business_id: profile.business_id,
          user_id: profile.id,
          action,
          entity_type: entityType,
          entity_id: entityId,
          changes: toJson(changes),
        });
      } catch {
        // Fire-and-forget — don't block the mutation
      }
    },
    [isDemo, profile?.business_id, profile?.id],
  );

  return { log };
}
